import { useEffect } from "react"
import { isIOS } from "react-device-detect"

export const useZoomDisable = (enabled: boolean): void => {
    // disable pinch zoom on touch devices
    useEffect(() => {
        if (!enabled) return

        const preventZoom = (
            event: Event & { scale?: number; touches?: any[] },
        ) => {
            if (
                (event.touches && event.touches.length > 1) ||
                (typeof event.scale === "number" && event.scale !== 1)
            ) {
                event.preventDefault()
            }
        }

        document.addEventListener("touchmove", preventZoom, { passive: false })
        // safari
        document.addEventListener("gesturestart", preventZoom)
        document.addEventListener("gesturechange", preventZoom)

        return () => {
            document.removeEventListener("touchmove", preventZoom)
            document.removeEventListener("gesturestart", preventZoom)
            document.removeEventListener("gesturechange", preventZoom)
        }
    }, [enabled])

    // disable through css
    useEffect(() => {
        if (!enabled) return

        const styleTag = document.createElement("style")
        styleTag.id = "zoom-disable-css"
        styleTag.textContent = `
      html, body {
        touch-action: manipulation !important;
      }
    `
        document.head.appendChild(styleTag)

        return () => {
            document.head.removeChild(styleTag)
        }
    }, [enabled])

    // update meta tags
    useEffect(() => {
        if (!enabled) return

        const metaViewport = document.querySelector(
            'meta[name="viewport"]',
        ) as HTMLMetaElement

        if (!metaViewport) return

        const originalContent = metaViewport.content

        const kvMap = new Map<string, string>(
            originalContent
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
                .map((part) => {
                    const [key, ...rest] = part.split("=")
                    return [key, rest.join("=")]
                }),
        )

        kvMap.set("width", "device-width")
        kvMap.set("initial-scale", "1")
        kvMap.set("maximum-scale", "1")
        kvMap.set("user-scalable", "no")
        if (!isIOS) {
            kvMap.set("interactive-widget", "resizes-content")
        }

        metaViewport.content = Array.from(kvMap, ([k, v]) => `${k}=${v}`).join(
            ", ",
        )

        return () => {
            metaViewport.content = originalContent
        }
    }, [enabled])
}
